export default __webpack_public_path__ + "6c2266ec24d12483b93da4b3fbf51da9.woff";